export default __webpack_public_path__ + "static/media/news-3.0197b26e.png";